import 'select2';



$(document).ready(function() {

	$('.jsSelect').select2({
		minimumResultsForSearch: -1,
		dropdownAutoWidth : true

	});

	$('.jsSelect').on('change', function () {
		if ($(this).val() !== '') {
			$(this).closest('.select').addClass('is-changed');
			$(this).closest('.select').removeClass('is-error');
		}
	})

});

